import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetStudentAllQuestionsQuery } from '../../slices/students/questionsApiSlice';
import { useGetStudentAllAnswersQuery } from '../../slices/students/questionsApiSlice';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import StudentOldQuestion from '../../components/StudentOldQuestion';
import StudentOldQuestion2 from '../../components/StudentOldQuestion2';
import NoAnswer from '../../components/NoAnswer';

const StudentPreviousAnswers = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [subjecttittle, setSubjecttittle] = useState('');
    const [studentname, setStudentname] = useState('');
    const [teachername, setTeachername] = useState('');

    const { studentInfo } = useSelector((state) => state.authStudent);

    const { data: allQuestions, isLoading, isError, error } = useGetStudentAllQuestionsQuery(id);

    const { data } = useGetPublicsubjectQuery(id);

    const { data: allAnswers, isLoading: isLoadingAnswers, isError: isErrorAnswers, error: errorAnswers } = useGetStudentAllAnswersQuery(id);

    useEffect(() => {
        if(data) {
            setTeachername(data?.firstname + ' ' + data?.lastname);
        }
    }, [data])

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
        if(studentInfo) {
            setStudentname(studentInfo.firstname + ' ' + studentInfo.lastname);
        }
    }, [navigate, studentInfo])

    let newArr = []
    let newArr2 = []
    let newArr3 = []
    let newArr4 = []

    if(allQuestions && allAnswers) {
         newArr = [...allQuestions, ...allAnswers]
    }

    for (let i = 0; i < newArr.length; i++) {
        for (let j = 0; j < newArr.length; j++) {
            if(newArr[i].question == newArr[j]._id) {
                newArr2.push([ newArr[j], newArr[i]])  
                newArr3.push(newArr[j]._id)  
            } 
        }
    }

    if (allQuestions ) {
        for (let i = 0; i < allQuestions.length; i++) {
            if (!newArr3.includes(allQuestions[i]._id)) {
                newArr4.push(allQuestions[i])
            }
        }
    }
    
    useEffect(() => {
        setSubjecttittle(newArr[0]?.subjectname)
    }, [newArr])

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader />
            <br /><br /><br /><br />
            <div className="container-fluid mt--6">
                {isLoading ? ( 
                    <Loader />
                ) : error ? (
                    <Message variant='danger'>
                        {error?.data?.message || error.error}
                    </Message>
                ) : (     
                    <div className="row">
                        {subjecttittle && 
                            <div className="col-xl-12 questionTitle">   
                                <h4>  <span className='tittleColor4 ' style={{textTransform: 'capitalize'}}>Subject: {subjecttittle}</span></h4>
                            </div>
                        }
                        {newArr4?.map((question2) => (
                            <div className="col-md-6 col-xl-4 ">   
                                <div className="card">                
                                    <div className="card-body">
                                        <div className="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">                       
                                            <StudentOldQuestion2 question={question2} teachername={teachername}  studentname={studentname}  />                   
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {newArr2?.map((question) => (
                            <div className="col-md-6 col-xl-4 ">   
                                <div className="card">                
                                    <div className="card-body">
                                        <div className="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">                       
                                            <StudentOldQuestion question={question} teachername={teachername}  studentname={studentname} />                   
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                        {allQuestions?.length == 0  && (
                            <div className="col-md-6 col-xl-4 ">  
                                <NoAnswer />                    
                            </div>
                        )}
                    </div>
                )}   
            </div>
        </div>      
    </div>
  )
}
export default StudentPreviousAnswers
